import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import AddNew from "./views/AddNew.vue";
import Login from "./views/Login.vue";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/index.html",
      alias: "/",
      name: "home",
      component: Home
    },
    {
      path: "/add-new",
      name: "add-new",
      component: AddNew
    },
    {
      path: "*",
      redirect: "/login"
    }
  ]
});

router.beforeEach((to, from, next) => {
  store.dispatch("fetchAccessToken");
  if (to.fullPath === "/") {
    if (!store.state.authToken) {
      next("/login");
    }
  }
  if (to.fullPath === "/index.html") {
    if (!store.state.authToken) {
      next("/login");
    }
  }
  if (to.fullPath === "/add-new") {
    if (!store.state.authToken) {
      next("/login");
    }
  }
  if (to.fullPath === "/login") {
    if (store.state.authToken) {
      next("/index.html");
    }
  }
  next();
});

export default router;
